.MobileCalendarGrid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.25rem;

  & > div {
    text-align: center;
    border-radius: 0.25rem;
    border: 1px solid var(--bs-gray-300);
    position: relative;
    cursor: pointer;

    & > .DayNumber {
      padding: 0.1rem 0.2rem 0.3rem 0.2rem;
    }

    & > .IndicatorSet {
      display: block;
      position: absolute;
      width: 100%;
      bottom: -6px;
      font-size: 1rem;
    }
  }

  & > .header {
    color: var(--bs-gray-500);
  }

  & > .selected {
    background-color: #2196f3;
    color: white;
  }

  & > .mon {
    grid-column: 1;
  }

  & > .tue {
    grid-column: 2;
  }

  & > .wed {
    grid-column: 3;
  }

  & > .thu {
    grid-column: 4;
  }

  & > .fri {
    grid-column: 5;
  }

  & > .sat {
    grid-column: 6;
  }

  & > .sun {
    grid-column: 7;
  }
}

.MobileCalendarHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;

  & .DayLabel {
    flex-grow: 1;
    text-align: center;
  }
}

.MobileCalendarEvent {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  gap: 0.5rem;
  line-height: 1.2rem;
  text-decoration: unset;
  border: 1px solid var(--bs-gray-300);
  border-radius: 0.25rem;

  & > div {
    padding: 0.25rem 0;
  }

  & > div:nth-child(1) {
    flex: 0 0 10px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  & > div:nth-child(2) {
    flex: 0 0 45px;
    text-align: right;
    color: var(--bs-gray-500);
  }

  & > div:nth-child(3) {
    flex: 0 0 45px;
    text-align: right;
    color: var(--bs-gray-500);
  }

  & > div:nth-child(4) {
    flex: 1 0 80px;
  }
}
